import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Grid,
  Pagination,
  Divider,
  TableSortLabel,
  Link,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import FileIcon from "@mui/icons-material/InsertDriveFile";
import DownloadIcon from "@mui/icons-material/Download";
import { get, post } from "../../utility/fetch2";
import notification from "../../utility/notification";
import { formatDate } from "../../utility/general";
import MedicationTable from "../tables/MedicationTable";
import AddMoreTreatment from "./AddMorePrescription";
import ViewVisit from "./visits";
import VitalsTreat from "./VitalsTreatment";
import TagInputs from "../UI/TagInputs";

// Styled components
const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    maxWidth: "95%",
    width: "95%",
    margin: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      width: "100%",
      margin: theme.spacing(1),
      maxHeight: "100vh",
    },
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

function DetailedNurseNotes({
  closeModal,
  treatment,
  doctors,
  nurses,
  patientId,
  patientName,
}) {
  const [nurseNotesModal, setNurseNotesModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [notes, setNotes] = useState([]);
  const [viewing, setViewing] = useState({});
  const [add, setAdd] = useState(false);
  const [showVitalsSection, setShowVitalsSection] = useState(false);
  const [vitals, setVitals] = useState([]);
  const [viewMeds, setViewMeds] = useState(false);
  const [meds, setMeds] = useState([]);

  const [documentArray, setDocumentArray] = useState([]);
  const [NotesModal, setNotesModal] = useState(false);

  const administrationFrequencies = [
    { id: 1, name: "Immediately" },
    { id: 2, name: "As needed" },
    { id: 3, name: "Once daily" },
    { id: 4, name: "Twice a day" },
    { id: 5, name: "Three times a day" },
    { id: 6, name: "Four times a day" },
    { id: 7, name: "At night" },
    { id: 8, name: "Morning" },
    { id: 9, name: "Evening" },
    { id: 10, name: "Every 24 hours" },
    { id: 11, name: "Every 12 hours" },
    { id: 12, name: "Every 8 hours" },
    { id: 13, name: "Every 6 hours" },
    { id: 14, name: "Every 4 hours" },
    { id: 15, name: "Every 3 hours" },
    { id: 16, name: "Every 2 hours" },
    { id: 17, name: "Every hour" },
    { id: 18, name: "Every 2 months" },
    { id: 19, name: "Every 3 months" },
  ];

  const drugStrengthUnits = [
    { id: 0, name: "Milligrams" },
    { id: 1, name: "Grams" },
    { id: 2, name: "Micrograms" },
    { id: 3, name: "Milliliters" },
    { id: 4, name: "Liters" },
    { id: 5, name: "Units" },
    { id: 6, name: "Puffs" },
    { id: 7, name: "Sprays" },
    { id: 8, name: "Drops" },
    { id: 9, name: "Patch" },
    { id: 10, name: "Bottle" },
    { id: 11, name: "TransdermalSystem" },
    { id: 12, name: "Tablet" },
    { id: 13, name: "Capsule" },
    { id: 14, name: "Suppository" },
    { id: 15, name: "Scoop" },
    { id: 16, name: "Sachet" },
    { id: 17, name: "Ampoule" },
    { id: 18, name: "Vial" },
    { id: 19, name: "InjectionPen" },
    { id: 20, name: "Enema" },
    { id: 21, name: "Ounces" },
    { id: 22, name: "Teaspoon" },
    { id: 23, name: "Tablespoon" },
    { id: 24, name: "Milliequivalents" },
    { id: 25, name: "InternationalUnits" },
  ];

  const routesOfAdministration = [
    { id: 1, name: "Orally" },
    { id: 2, name: "Sublingual" },
    { id: 3, name: "Topical" },
    { id: 4, name: "Inhalation" },
    { id: 5, name: "Suppository" },
    { id: 6, name: "IV" },
    { id: 7, name: "IM" },
    { id: 8, name: "Subcut" },
    { id: 9, name: "Intradermal" },
    { id: 10, name: "PerRectum" },
    { id: 11, name: "PerVagina" },
    { id: 12, name: "Implant" },
  ];

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const deleteDoc = (doc) => {
    let newArr = documentArray.filter((id) => id.name !== doc);
    setDocumentArray(newArr);
  };

  const getPrescriptionLog = async () => {
    try {
      const res = await get(
        `/patients/prescription-log?treatmentId=${treatment?.id}`,
      );
      setNotes(res);
      setTotalPages(res.length);
    } catch (error) {
      console.error("Error fetching prescription log:", error);
    }
  };

  const getVital = async () => {
    try {
      const res = await get(
        `/patients/vital-by-appointmentId?appointmentId=${treatment?.appointmentId}&pageIndex=1&Pagesize=100`,
      );
      const vital = res?.data?.find(
        (vital) => vital?.vitalId === treatment?.vitalId,
      );
      setVitals(vital);
      setTotalPages(res.length);
    } catch (error) {
      console.error("Error fetching prescription log:", error);
    }
  };

  console.log("vital", vitals, treatment);

  const addConsent = async () => {
    const payload = {
      id: 0,
      patientId: Number(patientId),
      clinicId: Number(sessionStorage.getItem("clinicId")),
      appointmentId: treatment?.appointmentId,
      docName: documentArray[0]?.name,
      docPath: documentArray[0]?.path,
    };
    try {
      let res = await post(`/patients/AddConsent`, payload);
      if (res?.appointmentId) {
        notification({
          message: "Consent added successfully",
          type: "success",
        });
        setDocumentArray([]);
      } else {
        notification({ message: "Failed to add consent", type: "error" });
      }
    } catch (error) {
      console.error("Error adding consent:", error);
    }
  };

  useEffect(() => {
    getPrescriptionLog();
    getVital();
    setMeds([...treatment?.medications, ...treatment?.otherMedications]);
  }, []);

  const selectRecord = (record) => {
    setViewing(record);
    setNotesModal(true);
  };

  const closeModals = () => {
    setViewing({});
    setNotesModal(false);
  };

  const currentNote = notes[currentPage - 1];

  return (
    <StyledDialog open={true} onClose={closeModal} fullWidth maxWidth="xl">
      <DialogTitle>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={1}
        >
          <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
            <Typography
              variant="h6"
              sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}
            >
              Nurse Notes
            </Typography>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ display: { xs: "none", sm: "block" } }}
            />
            <Typography
              variant="subtitle1"
              sx={{ fontSize: { xs: "0.85rem", sm: "1rem" } }}
            >
              {patientName} {treatment?.age} years
            </Typography>
          </Box>
          <IconButton
            onClick={closeModal}
            sx={{ padding: { xs: "4px", sm: "8px" } }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ padding: { xs: "8px", sm: "16px" } }}>
        <Box my={2}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}
          >
            First Vital
          </Typography>
          <TableContainer
            component={Paper}
            elevation={2}
            sx={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}
          >
            <Table size="small" sx={{ minWidth: { xs: "800px", sm: "auto" } }}>
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    sx={{
                      fontSize: { xs: "0.7rem", sm: "0.875rem" },
                      whiteSpace: "nowrap",
                    }}
                  >
                    Date
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: { xs: "0.7rem", sm: "0.875rem" },
                      whiteSpace: "nowrap",
                    }}
                  >
                    Weight (Kg)
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: { xs: "0.7rem", sm: "0.875rem" },
                      whiteSpace: "nowrap",
                    }}
                  >
                    Temp (°C)
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: { xs: "0.7rem", sm: "0.875rem" },
                      whiteSpace: "nowrap",
                    }}
                  >
                    Height (cm)
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: { xs: "0.7rem", sm: "0.875rem" },
                      whiteSpace: "nowrap",
                    }}
                  >
                    BMI
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: { xs: "0.7rem", sm: "0.875rem" },
                      whiteSpace: "nowrap",
                    }}
                  >
                    Heart (bpm)
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: { xs: "0.7rem", sm: "0.875rem" },
                      whiteSpace: "nowrap",
                    }}
                  >
                    Respiratory
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: { xs: "0.7rem", sm: "0.875rem" },
                      whiteSpace: "nowrap",
                    }}
                  >
                    Blood Pressure (mmHg)
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: { xs: "0.7rem", sm: "0.875rem" },
                      whiteSpace: "nowrap",
                    }}
                  >
                    ECG
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: { xs: "0.7rem", sm: "0.875rem" },
                      whiteSpace: "nowrap",
                    }}
                  >
                    Nurse Notes
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      fontSize: { xs: "0.7rem", sm: "0.875rem" },
                      whiteSpace: "nowrap",
                    }}
                  >
                    Administered Nurse
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <StyledTableCell
                    sx={{ fontSize: { xs: "0.7rem", sm: "0.875rem" } }}
                  >
                    {formatDate(vitals?.dateOfVisit)}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{ fontSize: { xs: "0.7rem", sm: "0.875rem" } }}
                  >
                    {vitals?.weight}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{ fontSize: { xs: "0.7rem", sm: "0.875rem" } }}
                  >
                    {vitals?.temperature} C
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{ fontSize: { xs: "0.7rem", sm: "0.875rem" } }}
                  >
                    {vitals?.height} cm
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{ fontSize: { xs: "0.7rem", sm: "0.875rem" } }}
                  >
                    {vitals?.bmi}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{ fontSize: { xs: "0.7rem", sm: "0.875rem" } }}
                  >
                    {vitals?.heartPulse} bpm
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{ fontSize: { xs: "0.7rem", sm: "0.875rem" } }}
                  >
                    {vitals?.respiratory}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{ fontSize: { xs: "0.7rem", sm: "0.875rem" } }}
                  >
                    {vitals?.bloodPressure}
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{ fontSize: { xs: "0.7rem", sm: "0.875rem" } }}
                  >
                    <Box>
                      {vitals?.vitalDocuments?.map((item, index) => (
                        <Box
                          key={index}
                          display="flex"
                          alignItems="center"
                          gap={1}
                          flexWrap="wrap"
                        >
                          <Link
                            href={item.docPath}
                            target="_blank"
                            sx={{ fontSize: { xs: "0.7rem", sm: "0.875rem" } }}
                          >
                            {item.docName}
                          </Link>
                          {item.docPath && (
                            <IconButton
                              size="small"
                              href={item.docPath}
                              target="_blank"
                              download
                              sx={{ padding: { xs: "2px", sm: "4px" } }}
                            >
                              <DownloadIcon fontSize="small" />
                            </IconButton>
                          )}
                        </Box>
                      ))}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{ fontSize: { xs: "0.7rem", sm: "0.875rem" } }}
                  >
                    <IconButton
                      size="small"
                      onClick={() => selectRecord(vitals)}
                      sx={{ padding: { xs: "2px", sm: "4px" } }}
                    >
                      <FileIcon fontSize="small" />
                    </IconButton>
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{ fontSize: { xs: "0.7rem", sm: "0.875rem" } }}
                  >
                    {vitals?.vitalNurseName}
                  </StyledTableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <Box my={3}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}
          >
            Medication
          </Typography>
          <Box sx={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
            <MedicationTable
              medications={meds}
              administrationFrequencies={administrationFrequencies}
              routesOfAdministration={routesOfAdministration}
              drugStrengthUnits={drugStrengthUnits}
            />
          </Box>
          <Button
            variant="contained"
            onClick={() => setAdd(true)}
            fullWidth
            sx={{
              mt: 2,
              bgcolor: "#17621A",
              "&:hover": { bgcolor: "#124E15" },
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              padding: { xs: "8px 12px", sm: "10px 16px" },
            }}
          >
            Add to existing prescriptions
          </Button>
        </Box>

        {currentNote ? (
          <>
            <div className="m-t-20">
              <h4 style={{ fontSize: "clamp(0.95rem, 3vw, 1.1rem)" }}>
                Admistration Information
              </h4>
              <div className="flex" style={{ flexWrap: "wrap", gap: "10px" }}>
                <div style={{ width: "100%" }}>
                  <div
                    className="w-100 flex m-t-20"
                    style={{ flexWrap: "wrap", gap: "8px" }}
                  >
                    <TagInputs
                      style={{
                        borderRight: "none",
                        flex: "1 1 150px",
                        minWidth: "150px",
                      }}
                      label={
                        currentNote?.createdAt
                          ? new Date(currentNote?.createdAt).toLocaleTimeString(
                              [],
                              { hour: "2-digit", minute: "2-digit" },
                            )
                          : "Date"
                      }
                      name="additionalNoteOnTreatment"
                      value={
                        currentNote?.createdAt
                          ? new Date(
                              currentNote?.createdAt,
                            ).toLocaleDateString()
                          : ""
                      }
                      readOnly={true}
                    />
                    <TagInputs
                      label="Nurse"
                      value={currentNote?.administeredBy}
                      readOnly={true}
                      style={{ flex: "1 1 150px", minWidth: "150px" }}
                    />
                  </div>
                </div>
              </div>
              <div
                style={{
                  overflowX: "auto",
                  WebkitOverflowScrolling: "touch",
                  marginTop: "16px",
                }}
              >
                <table
                  className="bordered-table-2"
                  style={{ minWidth: "600px" }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                          whiteSpace: "nowrap",
                          padding: "8px",
                        }}
                      >
                        Medication Name
                      </th>
                      <th
                        style={{
                          fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                          whiteSpace: "nowrap",
                          padding: "8px",
                        }}
                      >
                        Volume Given
                      </th>
                      <th
                        style={{
                          fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                          whiteSpace: "nowrap",
                          padding: "8px",
                        }}
                      >
                        Units
                      </th>
                      <th
                        style={{
                          fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                          whiteSpace: "nowrap",
                          padding: "8px",
                        }}
                      >
                        Administered By
                      </th>
                      <th
                        style={{
                          fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                          whiteSpace: "nowrap",
                          padding: "8px",
                        }}
                      >
                        Notes
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                          padding: "8px",
                        }}
                      >
                        {currentNote.medicationName}
                      </td>
                      <td
                        style={{
                          fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                          padding: "8px",
                        }}
                      >
                        {currentNote.volumeGiven}
                      </td>
                      <td
                        style={{
                          fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                          padding: "8px",
                        }}
                      >
                        {currentNote.units}
                      </td>
                      <td
                        style={{
                          fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                          padding: "8px",
                        }}
                      >
                        {currentNote.administeredBy}
                      </td>
                      <td
                        style={{
                          fontSize: "clamp(0.7rem, 2.5vw, 0.85rem)",
                          padding: "8px",
                        }}
                      >
                        {currentNote.otherNotes}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ) : (
          <div className="m-t-20 center-text">
            <h4>No Administration Information Available</h4>
          </div>
        )}

        <div className="m-t-20">
          <button
            className="submit-btn"
            onClick={() => setShowVitalsSection((prev) => !prev)}
            style={{
              width: "100%",
              fontSize: "clamp(0.8rem, 2.5vw, 0.95rem)",
              padding: "10px 16px",
            }}
          >
            {showVitalsSection ? "Hide Vitals Section" : "Show Vitals"}
          </button>
          {showVitalsSection && (
            <div className=" m-t-10">
              <VitalsTreat
                firstVitals={vitals}
                treatment={treatment}
                patientId={patientId}
              />{" "}
              {/* Render the Vitals component */}
            </div>
          )}
        </div>

        <Box display="flex" justifyContent="flex-end" mt={4} mb={2}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(_, page) => handlePageChange(page)}
            color="primary"
            shape="rounded"
          />
        </Box>
      </DialogContent>

      {/* Modals */}
      {add && (
        <AddMoreTreatment
          closeModal={() => setAdd(false)}
          patientId={patientId}
          treatment={treatment}
          visit={vitals}
        />
      )}

      {NotesModal && <ViewVisit visit={viewing} closeModal={closeModals} />}
    </StyledDialog>
  );
}

export default DetailedNurseNotes;
